(() => {
	document.addEventListener('DOMContentLoaded', () => {
		const btt = document.getElementById('backToTop');
		const hero =
			document.querySelector('.site-hero') ||
			document.querySelector('.page-header');

		if (!btt || !hero) {
			return;
		}

		const observer = new window.IntersectionObserver(
			([entry]) => {
				btt.classList.toggle('is-visible', !entry.isIntersecting);
			},
			{ threshold: 0 }
		);

		observer.observe(hero);

		btt.addEventListener('click', () => {
			const reduce = window.matchMedia(
				'(prefers-reduced-motion: reduce)'
			).matches;

			window.scrollTo({
				top: 0,
				behavior: reduce ? 'auto' : 'smooth',
			});
		});
	});
})();